import { SERVICES } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 bg-[#F6F5F1]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 mb-14">
          <div className="md:col-span-4">
            <div className="w-9 h-9 rounded-full bg-[#0A5C36] text-white flex items-center justify-center text-xs mb-4">
              ✦
            </div>
            <p className="text-[15px] leading-relaxed text-neutral-700 max-w-xs">
              I offer an extensive array of services and specialised
              disciplines, encompassing WordPress, Shopify &amp; WooCommerce
              development.
            </p>
          </div>
          <div className="md:col-span-8">
            <h2
              data-split="words"
              className="display text-[40px] sm:text-[56px] md:text-[80px] leading-[0.98] tracking-tight"
            >
              Services I offer
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {SERVICES.slice(0, 3).map((s, idx) => (
            <ServiceCard key={s.id} s={s} idx={idx} />
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
          <ServiceCard s={SERVICES[3]} idx={3} span />
          <div className="md:col-span-2 bg-black text-white rounded-[24px] p-8 md:p-10 flex flex-col justify-between relative overflow-hidden group">
            <div>
              <p className="text-xs tracking-[0.25em] uppercase text-neutral-400 mb-3">
                Not sure what you need?
              </p>
              <p className="display text-2xl sm:text-3xl md:text-4xl leading-tight">
                Let&apos;s hop on a{" "}
                <span className="text-[#FFE14D]">free 20-min call</span>
                <br />
                and figure it out together.
              </p>
            </div>
            <a
              href="#contact"
              data-book
              className="mt-8 h-12 pl-6 pr-2 rounded-full bg-white text-black text-sm font-semibold flex items-center gap-2 self-start group/btn hover:bg-[#FFE14D] transition-colors"
            >
              Book a free call
              <span className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center group-hover/btn:rotate-45 transition-transform">
                <ArrowUpRight size={16} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ s, idx }) {
  return (
    <div
      style={{ transitionDelay: `${idx * 80}ms` }}
      className={`${s.color} reveal rounded-[24px] p-6 md:p-7 relative overflow-hidden group hover:-translate-y-1 transition-all duration-500`}
    >
      <div className="flex items-start justify-between mb-6">
        <span className="inline-flex items-center gap-1.5 h-7 px-3 rounded-full bg-white/70 backdrop-blur text-xs font-medium">
          <span className="w-1.5 h-1.5 rounded-full bg-black" />
          {s.tag}
        </span>
        <button className="w-9 h-9 rounded-full bg-white text-black flex items-center justify-center group-hover:rotate-45 transition-transform">
          <ArrowUpRight size={16} />
        </button>
      </div>

      <div className="flex items-end gap-4 mb-2">
        <div className="flex-1">
          <h3 className="display text-2xl md:text-[28px] leading-tight">
            {s.title}
          </h3>
          <p className="text-sm text-black/70 mt-1">{s.subtitle}</p>
        </div>
        <img
          src={s.image}
          alt={s.title}
          loading="lazy"
          className="w-20 h-20 md:w-28 md:h-28 rounded-2xl object-cover shrink-0 group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      <p className="text-sm text-black/80 mt-4 leading-relaxed">{s.desc}</p>

      <div className="flex flex-wrap gap-1.5 mt-4">
        {s.bullets.map((b) => (
          <span
            key={b}
            className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-white/60 backdrop-blur"
          >
            {b}
          </span>
        ))}
      </div>
    </div>
  );
}
